/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAdminProfileReport$Request {
    requestBody: Array<number>;
}

export interface GetAdminProfileReport$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminProfileReportRequest = createAction<PayloadData<void, GetAdminProfileReport$Request>>('ADMIN_PROFILE_REPORTS__GET_ADMIN_PROFILE_REPORT__REQUEST');
export const getAdminProfileReportSuccess = createAction<PayloadData<any, GetAdminProfileReport$Request>>('ADMIN_PROFILE_REPORTS__GET_ADMIN_PROFILE_REPORT__SUCCESS');
export const getAdminProfileReportFailure = createAction<PayloadData<Error, GetAdminProfileReport$Request, true>>('ADMIN_PROFILE_REPORTS__GET_ADMIN_PROFILE_REPORT__FAILURE');

export const getAdminProfileReportActions = [
    getAdminProfileReportRequest,
    getAdminProfileReportSuccess,
    getAdminProfileReportFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminProfileReport = (meta: GetAdminProfileReport$Request, config?: GetAdminProfileReport$Config) => {
    return {
        DOWNLOAD_FILE: {
            types: getAdminProfileReportActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/admin/profiles`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/octet-stream, application/json',
            }
        },
        ...meta
    }
};

